import {type RouteLocationRaw, useRoute} from 'vue-router';
import type {AccountRouteName} from '@/ts/router/pages-path';
import {computed, type ComputedRef} from 'vue';

/** Provides helpers for navigating between account sub-routes while preserving route params */
export function useAccountRoute(): {
  toAccount(name: AccountRouteName): RouteLocationRaw;
  isActive(name: AccountRouteName): boolean;
  currentName: ComputedRef<string | undefined>;
} {
  const route = useRoute();
  const currentName = computed(() => typeof route.name === 'string' ? route.name : void 0);

  function toAccount(name: AccountRouteName): RouteLocationRaw {
    return {name, params: {...route.params}};
  }

  function isActive(name: AccountRouteName): boolean {
    return route.name === name;
  }

  return {toAccount, isActive, currentName};
}
